import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ y }}
    whileInView={{ y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, delay = 0.1, className = "" }) => (
  <>
    {lines.map((l, i) => (
      <span key={i} className={`block overflow-hidden pb-[0.06em] ${className}`}>
        <motion.span
          className="block will-change-transform"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.1 }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </>
);

export const Marquee = ({ items, testid = "editorial-marquee" }) => (
  <div className="marquee relative overflow-hidden border-y border-line py-6" data-testid={testid} aria-label="Key Denver furnace considerations">
    <div className="marquee-track flex w-max gap-12 whitespace-nowrap">
      {[...items, ...items].map((t, i) => (
        <span key={i} aria-hidden={i >= items.length} className="flex items-center gap-12 font-display text-3xl uppercase tracking-tight text-ink/80 sm:text-4xl">
          {t}
          <span className="inline-block h-2 w-2 rotate-45 bg-flame-deep" aria-hidden="true" />
        </span>
      ))}
    </div>
  </div>
);
